import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { DownloadModalComponent } from './modals/download-modal/download-modal.component';

import { CustomerFilterPipe } from '../shared/customer-filter.pipe';
import { NoValuePipe } from '../pipes/no-value.pipe';

@NgModule({
  declarations: [
    DownloadModalComponent,
    CustomerFilterPipe,
    NoValuePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    CustomerFilterPipe,
    NoValuePipe
  ],
  providers: [],
  entryComponents: [
    DownloadModalComponent
  ]
})
export class SharedModule { }
